import { useContext, useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { BrowseFilters, readBrowseFilters } from '../lib/browse_params'
import { Filters } from '../types'
import { SearchContext } from '../contexts/search_context'

const signature = (filters: Filters, query: string) => JSON.stringify({
  game: filters.selectedGame ?? null,
  view: filters.selectedView,
  cardTypes: filters.selectedCardTypes,
  energyTypes: filters.selectedEnergyTypes,
  rarities: filters.selectedRarities,
  conditions: filters.selectedConditions,
  stocks: filters.selectedStocks,
  min: filters.priceRange.min ?? null,
  max: filters.priceRange.max ?? null,
  userId: filters.selectedUserId ?? null,
  query,
})

const filtersFromBrowse = (filters: Filters, browse: BrowseFilters): Filters => ({
  ...filters,
  selectedGame: browse.game,
  selectedView: browse.view,
  selectedCardTypes: browse.cardTypes,
  selectedEnergyTypes: browse.energyTypes,
  selectedRarities: browse.rarities,
  selectedConditions: browse.conditions,
  selectedStocks: browse.stocks,
  priceRange: {
    min: browse.minPrice,
    max: browse.maxPrice,
  },
  selectedUserId: browse.userId,
})

const useFilterQueryString = (): BrowseFilters => {
  const location = useLocation()
  const { filters, setFilters, filterMenuDisplayed, searchString, setSearchString } = useContext(SearchContext)
  const browse = useMemo(() => readBrowseFilters(location.search, location.pathname), [location.pathname, location.search])

  useEffect(() => {
    if (!setFilters || filterMenuDisplayed) return

    const next = filtersFromBrowse(filters, browse)
    if (signature(filters, searchString) === signature(next, browse.query)) return

    if (searchString !== browse.query) setSearchString?.(browse.query)
    setFilters(next)
  }, [browse, filterMenuDisplayed, filters, searchString, setFilters, setSearchString])

  return browse
}

export { useFilterQueryString }
